import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
    getFontSize,
    getFontWeight,
} from "../../components/CustomText";
import CustomBoard from "../../components/CustomBoard";
import "fontsource-muli";
import CustomButton from "../../components/CustomButton";
import { withRouter } from "react-router-dom";
import Image from "../../../assets";
import { borderRadius } from "@material-ui/system";

class ReceivedRequest extends Component {

    constructor(props) {
        super(props);
        this.state = {
            height: 0,
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ height: window.innerHeight });
    }

    onClickReturnToLogin = () => {
        const { history } = this.props;
        history.push("/Login")
    };

    renderChildren = () => {
        const { classes } = this.props;

        return (
            <div className={classes.contentContainer}>
                <img src={Image.celebrativeIcon} />
                <CustomText design={classes.headerTextStyle}>We have received your request</CustomText>
                <CustomText design={classes.headerTextStyleV2}>Our team is currently reviewing the details. We will follow up with you as soon as possible.</CustomText>
                <CustomButton
                    title={"Back"}
                    design={classes.buttonStyle}
                    onClick={this.onClickReturnToLogin}
                />
            </div>
        );
    };

    render() {
        const { classes } = this.props;
        const { height } = this.state;
        return (
            <div className={classes.root}>
                <CustomBoard
                    children={this.renderChildren()}
                    height={height}
                />
            </div>
        )
    }
}

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: "white",
    },
    headerTextStyle: {
        ...getFontWeight("bold"),
        fontSize: 20,
        textAlign: "center",
        color: "#171717",
        marginTop: 20
    },
    headerTextStyleV2: {
        fontSize: 16,
        textAlign: "center",
        color: "#686868",
        marginTop: 20,
        fontWeight:"normal !important"
    },
    buttonStyle: {
        // width: 160,
        marginTop: 25,
        height:56,
        borderRadius:4
    },
    imageStyle: {
        width: 100,
        height: 100
    },
    contentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }
});

export default withStyles(styles, { withTheme: true })(withRouter(ReceivedRequest));